import gql from 'graphql-tag';

export const GRAPHQL_QUERY_USERS = gql`
  query users($criteria: CriteriaInput!) {
    users(criteria: $criteria) {
      rows {
          id
          firstName
          lastName
          role
          isActive
          email
          postalCode
          civility
          birthDate
          mobilePhone
          createdAt
          isDeleted
      }
        total
        id
    }
  }
`;

export const GRAPHQL_QUERY_ADMINS = gql`
    query users($criteria: CriteriaInput!) {
        users(criteria: $criteria) {
            rows {
                id
                firstName
                lastName
                role
                isActive
                email
                postalCode
                civility
                birthDate
                mobilePhone
                createdAt
                isDeleted
            }
            total
            id
        }
    }
`;

export const GRAPHQL_MUTATION_REGISTER_ADMIN = gql`
    mutation registerAdmin($userInput: RegisterUserInput!) {
        registerAdmin(userInput: $userInput) {
            id
        }
    }
`;

export const GRAPHQL_MUTATION_UPDATE_USER_OR_ADMIN = gql`
    mutation updateUserOrAdmin($userInput: UpdateUserInput!) {
        updateUserOrAdmin(userInput: $userInput) {
            id
            firstName
            lastName
            street
            city
            postalCode
        }
    }
`;

export const GRAPHQL_MUTATION_DELETE_USER = gql`
  mutation deleteUser($userId: ID!) {
    deleteUser(userId: $userId)
  }
`;

export const GRAPHQL_MUTATION_REGISTER_USER = gql`
    mutation registerUser($input: RegisterUserInput!) {
        registerUser(userInput: $input) {
            id
            firstName
            lastName
            birthDate
            postalCode
        }
    }
`;


export const GRAPHQL_MUTATION_FORGOT_ACCOUNT_PASSWORD = gql`
    mutation forgotAccountPassword($email: String!) {
        forgotAccountPassword(email: $email)
    }
`;


export const GRAPHQL_MUTATION_RESET_ACCOUNT_PASSWORD = gql`
    mutation resetAccountPassword($token: String!, $password: String!) {
        resetAccountPassword(token: $token,password: $password)
    }
`;


